module.exports = __webpack_public_path__ + "static/media/logo_.d5b11704.svg";